import { makeStyles } from '@material-ui/core/styles'
import InsuranceTile from 'src/components/BuyPolicy/insuranceScreens/health/InsuranceTile'
import { useEffect } from 'react'
import { scrollToTop } from 'src/utils/commonMethods'
import EmptyInsuranceDetails from 'src/components/BuyPolicy/common/EmptyInsuranceDetails'

const HealthInsuranceDetailsManual = ({ insuranceQuotes, loading }) => {
  const classes = useStyles()

  useEffect(() => {
    scrollToTop()
  }, [])

  const showNoDetails = () => {
    return !insuranceQuotes?.length
  }

  const renderContent = () => {
    if (showNoDetails()) {
      if (!loading) {
        return <EmptyInsuranceDetails />
      } else {
        return null
      }
    } else {
      return (
        <div className={classes.mainContainer}>
          <div className={classes.insuranceListContainer}>
            {insuranceQuotes?.map((quote) => (
              <div key={`insuranceQuote_${quote?.enquiryId}`}>
                <InsuranceTile insuranceDetails={quote} />
              </div>
            ))}
          </div>
        </div>
      )
    }
  }

  return <>{renderContent()}</>
}

export default HealthInsuranceDetailsManual

export const useStyles = makeStyles({
  mainContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    marginTop: '20px',
    animation: '$slideFromBottom 1s ease-out',
  },
  insuranceListContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    gap: '20px',
    animation: '$slideFromBottom 1s ease-out',
  },
  '@keyframes slideFromBottom': {
    '0%': {
      transform: 'translateY(100%)',
    },
    '100%': {
      transform: 'translateY(0)',
    },
  },
})
